import type { HTMLAttributes } from 'react';

type BadgeColor = 'green' | 'red' | 'amber' | 'orange' | 'blue' | 'violet' | 'pink' | 'cyan' | 'default';

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  color?: BadgeColor;
  children: React.ReactNode;
}

const colorClasses: Record<BadgeColor, string> = {
  green: 'bg-green-bg text-green',
  red: 'bg-red-bg text-red',
  amber: 'bg-amber-bg text-amber',
  orange: 'bg-orange-bg text-orange',
  blue: 'bg-blue-bg text-blue',
  violet: 'bg-violet-bg text-violet',
  pink: 'bg-pink-bg text-pink',
  cyan: 'bg-cyan-bg text-cyan',
  default: 'bg-surface text-ink-3',
};

export function Badge({ color = 'default', className = '', children, ...props }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 text-[10px] font-bold px-2.5 py-0.5 rounded-md tracking-wide ${colorClasses[color]} ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}
